/*
This file was created by the script build.py 
*/


var categoryCollisionSystemState = {
    checked : false,
    indeterminate : false
}

var categoryAcceleratorParametersState = {
    checked : false,
    indeterminate : false
}

var categoryPhysicsThemeState = {
    checked : false,
    indeterminate : false
}

var categoryWorkingGroupState = {
    checked : false,
    indeterminate : false
}

var categoryFinalStatesState = {
    checked : false,
    indeterminate : false
}

var categoryFinalStatesSignatureState = {
    checked : false,
    indeterminate : false
}

var categoryInterpretationState = {
    checked : false,
    indeterminate : false
}

var categorySmAnalysisCharacteristicsState = {
    checked : false,
    indeterminate : false
}

var categoryFurtherSearchCategorisationState = {
    checked : false,
    indeterminate : false
}

var categoryFurtherCategorisationHeavyIonState = {
    checked : false,
    indeterminate : false
}


export const allCheckboxesState = {
    
    "categoryCollisionSystem" : categoryCollisionSystemState,
    
    "categoryAcceleratorParameters" : categoryAcceleratorParametersState,
    
    "categoryPhysicsTheme" : categoryPhysicsThemeState,
    
    "categoryWorkingGroup" : categoryWorkingGroupState,
    
    "categoryFinalStates" : categoryFinalStatesState,
    
    "categoryFinalStatesSignature" : categoryFinalStatesSignatureState,
    
    "categoryInterpretation" : categoryInterpretationState,
    
    "categorySmAnalysisCharacteristics" : categorySmAnalysisCharacteristicsState,
    
    "categoryFurtherSearchCategorisation" : categoryFurtherSearchCategorisationState,
    
    "categoryFurtherCategorisationHeavyIon" : categoryFurtherCategorisationHeavyIonState,
    
}